/** The customer-facing second screen. Read by shoppers, so it uses their words, not the till's. */
export default {
  'display.title': 'Customer display',
  'display.welcome': 'Welcome',
  'display.waiting': 'Waiting for the till',
  'display.waitingHint': 'Open the till in another window on this computer, then sign in. This screen follows it.',
  'display.welcomeTo': 'Welcome to {store}',
  'display.idleHint': 'Your items and the total will show here as they are billed.',
  'display.thanks': 'Thank you!',
  'display.thanksName': 'Thank you, {name}!',
  'display.paid': 'Paid ₹{amount}',
  'display.change': 'your change ₹{amount}',
  'display.saved': 'You saved ₹{amount} today',
  'display.welcomeBack': 'Welcome back, {name}!',
  'display.onBill': { one: '{count} item on your bill', other: '{count} items on your bill' },
  'display.lineSave': 'you save ₹{amount}',
  'display.footer': 'Prices include GST. Ask the cashier for a printed or WhatsApp receipt.',
  'display.totalToPay': 'TOTAL TO PAY',
  'display.totalSoFar': 'TOTAL SO FAR',
  'display.saving': 'You save ₹{amount} today',
  'display.scanToPay': 'Scan to pay ₹{amount} by UPI',
  'display.anyUpi': 'Scan with any UPI app',
  'display.to': '₹{amount} to {payee}',
  'display.taking': 'The cashier is taking your payment.',
  'display.filled': 'The amount is already filled in. Paying by cash or card instead? Just tell the cashier.',
} as const;
